import React from "react";
import './invoice.css'
const InvoiceHeader = ({ invoice }) => {
  return (
    <>
      <div className="invoice-header">

        {/* LEFT */}
        <div className="header-left">

          <img
            src="/static/logo140.png"
            alt="Leon Gallery"
            className="company-logo"
          />

          <div className="bill-to">

            <div className="bill-title">
              BILL TO
            </div>

            <div className="bill-line"></div>

            <div className="bill-name">
              {invoice.customerName}
            </div>

          </div>

        </div>

        {/* RIGHT */}
        <div className="header-right">

          <h1>INVOICE</h1>

          <table className="invoice-info">

            <tbody>

              <tr>
                <td>Invoice No.</td>
                <td>{invoice.invoiceNo}</td>
              </tr>

              <tr>
                <td>Auction</td>
                <td>{invoice.auctionName}</td>
              </tr>

              <tr>
                <td>Date</td>
                <td>{invoice.date}</td>
              </tr>

            </tbody>

          </table>

        </div>

      </div>
    </>
  );
};

export default InvoiceHeader;